import React from 'react'

const statusStyles = {
  approved: 'bg-green-50 text-green-700 border-green-100',
  active: 'bg-emerald-50 text-emerald-700 border-emerald-100',
  completed: 'bg-blue-50 text-blue-700 border-blue-100',
  rejected: 'bg-red-50 text-red-700 border-red-100',
  under_review: 'bg-amber-50 text-amber-700 border-amber-100',
  manual_review: 'bg-amber-50 text-amber-700 border-amber-100',
  awaiting_disbursement: 'bg-violet-50 text-violet-700 border-violet-100'
}

export default function TableList({ user }) {
  if (!user) return null

  const formatCurrency = (amount) => {
    const number = Number(amount || 0)
    return Number.isFinite(number) ? `₦${number.toLocaleString()}` : '₦0'
  }

  const status = user.status || 'pending'
  const statusClass = statusStyles[status] || 'bg-gray-50 text-gray-600 border-gray-200'

  return (
    <tr className="border-t border-gray-100 transition hover:bg-gray-50/80">
      <td className="px-5 py-4">
        <p className="font-semibold text-gray-900">{user.email || '—'}</p>
        <p className="mt-1 text-xs text-gray-400">
          {user.id ? `Application #${user.id}` : 'Rent application'}
        </p>
      </td>

      <td className="px-5 py-4">
        <span className={`inline-flex rounded-full border px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide ${statusClass}`}>
          {status.replaceAll('_', ' ')}
        </span>
      </td>

      <td className="px-5 py-4 font-bold text-gray-900">{formatCurrency(user.rent_amount)}</td>
      <td className="max-w-[240px] px-5 py-4 text-gray-600" title={user.address || ''}>
        <p className="truncate">{user.address || '—'}</p>
      </td>
      <td className="max-w-[260px] px-5 py-4 text-gray-600" title={user.property_address || ''}>
        <p className="truncate">{user.property_address || '—'}</p>
      </td>
      <td className="px-5 py-4 text-gray-600">{user.landlord_phone_number || '—'}</td>
      <td className="px-5 py-4 text-gray-600">{user.landlord_account_bank || '—'}</td>
      <td className="px-5 py-4 font-mono text-xs text-gray-600">{user.landlord_account_number || '—'}</td>
      <td className="px-5 py-4 font-medium text-gray-700">{user.landlord_account_name || '—'}</td>
    </tr>
  )
}
